import React from "react";
import Sidebar from "./Sidebar";
import { Outlet, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Global Cmd/Ctrl+K → /search shortcut. Skips when a text input already
// has focus (so typing "k" in an existing search / textarea is unaffected).
function GlobalSearchShortcut() {
  const nav = useNavigate();
  React.useEffect(() => {
    const onKey = (e) => {
      const isCmdK = (e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K");
      if (!isCmdK) return;
      const el = document.activeElement;
      const inField =
        el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
      // Allow ⌘K from anywhere including inside inputs (matches Slack/GitHub UX).
      // We only guard by not double-routing when already on /search.
      if (window.location.pathname === "/search") return;
      e.preventDefault();
      // If a text was pre-selected, seed the search with it.
      const sel = (window.getSelection && window.getSelection().toString().trim()) || "";
      const target = sel ? `/search?q=${encodeURIComponent(sel.slice(0, 64))}` : "/search";
      nav(target);
      // Silence unused-var lint
      void inField;
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [nav]);
  return null;
}

export default function AppLayout() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // route to onboarding if incomplete (except when already there)
  if (user.onboarding_complete === false && loc.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <GlobalSearchShortcut />
      {loc.pathname !== "/onboarding" && <Sidebar />}
      <main className="flex-1 overflow-x-hidden" data-testid="app-main">
        <Outlet />
      </main>
    </div>
  );
}
